import {resource} from '@albert-io/json-api-framework/request/builder';

export default function getClassroomInvitationsQuery(studentEmail: string) {
  return resource('classroom_invitations_v1')
    .mandarkEndpoint(['classroom_invitations_v1'])
    .include('classroom_v1')
    .filter({
      email: encodeURIComponent(studentEmail),
      accepted_at: {
        null: true
      },
      classroom_v1: {
        status: 'active'
      }
    });
}
